
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_URL from "../../config/api";
import "./productList.css";

const ProductList = () => {
  const [data, setData] = useState([]);

  // =====================
  // FETCH PRODUCTS
  // =====================
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${API_URL}/api/products`);
        const result = await res.json();

        const productArray = Array.isArray(result)
          ? result
          : result.products;

        if (!productArray) return;

        const formatted = productArray.map((item) => ({
          id: item.id,
          productName: item.name,
          productImage: item.image,
          productStock: item.stock,
          productPrice: item.price,
          status: item.status || "Active",

          isFeatured: item.isFeatured,
          isPopular: item.isPopular,
          isTrending: item.isTrending,
          isTopSelling: item.isTopSelling,
          isDealsOfDay: item.isDealsOfDay,

          isBanner: item.isBanner,
          isAd: item.isAd,
          isRecentlyAdded: item.isRecentlyAdded,
          isTopRated: item.isTopRated,
        }));

        setData(formatted);
      } catch (err) {
        console.error(err);
      }
    };

    fetchProducts();
  }, []);

  // =====================
  // DELETE PRODUCT
  // =====================
  const handleDelete = async (id) => {
    await fetch(`${API_URL}/api/products/${id}`, {
      method: "DELETE",
    });

    setData((prev) => prev.filter((item) => item.id !== id));
  };

  // =====================
  // TOGGLE API CALL
  // =====================

  const toggleFlag = async (productId, field, value) => {
  try {
    await fetch(`${API_URL}/api/product-flags/${productId}/flags`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        [field]: value,
      }),
    });

    // instant UI update
    setData((prev) =>
      prev.map((item) =>
        item.id === productId ? { ...item, [field]: value } : item
      )
    );
  } catch (err) {
    console.error(err);
  }
};
  // const toggleFlag = async (productId, field, value) => {
  //   try {
  //     await fetch(`${API_URL}/api/product-flags/${productId}/flags`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         [field]: value,
  //       }),
  //     });

  //     // instant UI update
  //     setData((prev) =>
  //       prev.map((item) =>
  //         item.id === productId
  //           ? { ...item, [field]: value }
  //           : item
  //       )
  //     );
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // =====================
  // BUTTON STYLE (GREEN / RED)
  // =====================
  const flagButton = (active) => ({
    padding: "5px 8px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "2px",
    color: "white",
    backgroundColor: active ? "green" : "red",
    fontSize: "11px",
  });

  const columns = [
    { field: "id", headerName: "ID", width: 90 },

    {
      field: "product",
      headerName: "Product",
      width: 200,
      renderCell: (params) => (
        <div className="productListItem">
          <img src={params.row.productImage} className="productListImg" />
          {params.row.productName}
        </div>
      ),
    },

    { field: "productStock", headerName: "Stock", width: 90 },
    { field: "productPrice", headerName: "Price", width: 90 },
    { field: "status", headerName: "Status", width: 100 },

    // =====================
    // FLAGS COLUMN
    // =====================
    {
      field: "flags",
      headerName: "Controls",
      width: 500,
      renderCell: (params) => {
        const row = params.row;

        return (
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            
            {/* <button
              style={flagButton(row.isFeatured)}
              onClick={() =>
                toggleFlag(row.id, "isFeatured", !row.isFeatured)
              }
            >
              Featured
            </button>

            <button
              style={flagButton(row.isPopular)}
              onClick={() =>
                toggleFlag(row.id, "isPopular", !row.isPopular)
              }
            >
              Popular
            </button>

            <button
              style={flagButton(row.isTrending)}
              onClick={() =>
                toggleFlag(row.id, "isTrending", !row.isTrending)
              }
            >
              Trending
            </button>

            <button
              style={flagButton(row.isTopSelling)}
              onClick={() =>
                toggleFlag(row.id, "isTopSelling", !row.isTopSelling)
              }
            >
              Top
            </button>

            <button
              style={flagButton(row.isDealsOfDay)}
              onClick={() =>
                toggleFlag(row.id, "isDealsOfDay", !row.isDealsOfDay)
              }
            >
              Deals
            </button>

            <button
              style={flagButton(row.isBanner)}
              onClick={() =>
                toggleFlag(row.id, "isBanner", !row.isBanner)
              }
            >
              Banner
            </button>

            <button
              style={flagButton(row.isAd)}
              onClick={() =>
                toggleFlag(row.id, "isAd", !row.isAd)
              }
            >
              Ads
            </button>

            <button
              style={flagButton(row.isTopRated)}
              onClick={() =>
                toggleFlag(row.id, "isTopRated", !row.isTopRated)
              }
            >
              Top Rated
            </button> */}

            <button
  style={flagButton(row.isFeatured)}
  onClick={() => toggleFlag(row.id, "isFeatured", !row.isFeatured)}
>
  Featured
</button>

<button
  style={flagButton(row.isPopular)}
  onClick={() => toggleFlag(row.id, "isPopular", !row.isPopular)}
>
  Popular
</button>

<button
  style={flagButton(row.isTrending)}
  onClick={() => toggleFlag(row.id, "isTrending", !row.isTrending)}
>
  Trending
</button>

<button
  style={flagButton(row.isTopSelling)}
  onClick={() => toggleFlag(row.id, "isTopSelling", !row.isTopSelling)}
>
  Top
</button>

<button
  style={flagButton(row.isDealsOfDay)}
  onClick={() => toggleFlag(row.id, "isDealsOfDay", !row.isDealsOfDay)}
>
  Deals
</button>

<button
  style={flagButton(row.isBanner)}
  onClick={() => toggleFlag(row.id, "isBanner", !row.isBanner)}
>
  Banner
</button>

<button
  style={flagButton(row.isAd)}
  onClick={() => toggleFlag(row.id, "isAd", !row.isAd)}
>
  Ads
</button>

<button
  style={flagButton(row.isTopRated)}
  onClick={() => toggleFlag(row.id, "isTopRated", !row.isTopRated)}
>
  Top Rated
</button>

          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <>
          <Link to={`/product/${params.row.id}`}>
            <button className="productListEdit">Edit</button>
          </Link>

          <DeleteOutlineIcon
            className="productListDelete"
            onClick={() => handleDelete(params.row.id)}
          />
        </>
      ),
    },
  ];

  return (
    <div className="productList" style={{ height: 600 }}>
      <Link to="/NewProduct">
        <button className="addProductBtn">Add Product</button>
      </Link>

      <DataGrid rows={data} columns={columns} pageSize={8} />
    </div>
  );
};

export default ProductList;